import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import Popover from 'chameleon/ui-stack/ui/base/popover';

import './index.scss';

const PopOverTriggerIcon = ({ width = 12, height = 12, textColor }) => (
  <Icon
    id="info_circle_gray_14"
    width={width}
    height={height}
    className={textColor}
    accessibility={{ ariaHidden: true }}
  />
);

/**
 * Display an informational popover.
 * */
const InformationalPopover = ({
  className,
  buttonClassName,
  message,
  children,
  tabIndex,
  trigger,
  size,
  accessibility,
  isHTML = false,
  defaultOpen = false,
  withPortal,
  iconWidth,
  iconHeight,
  iconTextColor = 'text-gray-600',
  disabled,
}) => (
  <Popover
    className={cn('InformationalPopover normal-case text-left', {
      'cursor-pointer': !disabled,
      'cursor-default': disabled,
    })}
    buttonClassName={buttonClassName}
    withPortal={withPortal}
    defaultOpen={defaultOpen}
    size={size}
    tabIndex={tabIndex}
    accessibility={accessibility}
    disabled={disabled}
    trigger={
      trigger || (
        <PopOverTriggerIcon
          width={iconWidth}
          height={iconHeight}
          textColor={iconTextColor}
        />
      )
    }
  >
    <div className="popover-container" tabIndex={tabIndex}>
      <div className={cn('popover-info', className)}>
        {(isHTML && message && (
          <div dangerouslySetInnerHTML={{ __html: message }} />
        )) ||
          (message && message) ||
          (children && children) ||
          "There isn't any information available."}
      </div>
    </div>
  </Popover>
);

InformationalPopover.displayName = 'InformationalPopover';

InformationalPopover.propTypes = {
  // The trigger icon
  trigger: PropTypes.node,
  // The class name to custom style the content.
  className: PropTypes.string,
  // Custom classNames for the button
  buttonClassName: PropTypes.string,
  // The message to display.
  message: PropTypes.node,
  // The accessibility props.
  accessibility: PropTypes.object,
  // The component to display.
  children: PropTypes.node,
  withPortal: PropTypes.bool,
};

InformationalPopover.defaultProps = {
  trigger: null,
  className: null,
  buttonClassName: null,
  message: null,
  accessibility: null,
  children: null,
  withPortal: false,
};

export default InformationalPopover;
